export const MENU = Object.freeze({
  SOLUTIONS: 'SOLUTIONS',
  MORE_RESOURCES: 'MORE_RESOURCES',
});

export const GLOBAL_NAV_HEIGHT = 50;
